"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabsPropTypes = exports.tabsDefaultProps = undefined;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var tabsDefaultProps = exports.tabsDefaultProps = {
  bordered: true,
  customLink: null,
  customPanel: null,
  defaultIndex: null,
  disableSidebar: false,
  inlineLinks: false,
  items: [],
  onSelect: null,
  reset: false,
  selectedIndex: null,
  sidebarOnRight: false,
  sidebarWidth: 12,
  style: {},
  title: null
};
var tabsPropTypes = exports.tabsPropTypes = {
  bordered: _propTypes2.default.bool,
  customLink: _propTypes2.default.func,
  customPanel: _propTypes2.default.func,
  defaultIndex: _propTypes2.default.number,
  disableSidebar: _propTypes2.default.bool,
  inlineLinks: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    link: _propTypes2.default.node.isRequired,
    panel: _propTypes2.default.node.isRequired
  })),
  onSelect: _propTypes2.default.func,
  reset: _propTypes2.default.bool,
  selectedIndex: _propTypes2.default.number,
  sidebarOnRight: _propTypes2.default.bool,
  sidebarWidth: _propTypes2.default.number,
  style: _propTypes2.default.shape({}),
  title: _propTypes2.default.node
};